import { CoreUiException } from "./core-ui-exception";

/**
 * Method parameters are invlid
 */
export class InvalidParametersException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("InvalidParametersException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, InvalidParametersException.prototype);
    }
}
